import type { ComponentProps } from 'react'
import ValidatorResults from '@/app/(app)/tools/llms-txt-validator/components/ValidatorResults'
import type { ToolDetailProps } from './detailRegistry'

/**
 * Dashboard detail renderer for `llms` (Phase 3, Step 7 — Class A, dashboard-reuse).
 *
 * REUSES the public `ValidatorResults` with `variant="dashboard"`, which hides the
 * public-only chrome (the email-share widget, PlatformCTA, and the gradient services
 * CTA). The platform route (`/api/platform/tools/llms-validator`) runs the same lib
 * and returns the same `LlmsValidatorResult`, so the dashboard `data` maps straight
 * onto `ValidatorResults` — the dashboard now shows the full rich llms.txt report
 * (score breakdown + `buildFindings`, sections, internal/external links via
 * `sanitizeHref`, parsed metadata, collapsible raw view, recommendations + blog
 * links) instead of the generic panel.
 *
 * Wrapped in `id="tool-detail-panel"` so the dashboard scroll-to-panel still works.
 * Grade comes from `data.grade` (the lib's 80/65/50/35 curve) — never recomputed.
 * Render-layer only.
 */
export function LlmsDashboardDetail({ data }: ToolDetailProps) {
  const result = data as unknown as ComponentProps<
    typeof ValidatorResults
  >['result']
  return (
    <div
      id='tool-detail-panel'
      className='rounded-xl border border-border bg-card p-5'
    >
      <ValidatorResults result={result} variant='dashboard' />
    </div>
  )
}
